import { Component } from '@angular/core';

@Component({
  selector: 'app-installation-setup-layout',
  templateUrl: './installation-setup-layout.component.html',
  styleUrls: ['./installation-setup-layout.component.scss'],
})
export class InstallationSetupLayoutComponent {}
